import React from "react";
import { connect } from "react-redux";
import "./_MemoryEditView.scss";
import {
  toggleNecklaceSelectModal,
  toggleShowEditMemoryInModal,
  selectActiveMemory,
} from "../../redux/actions";
import { ButtonRounded } from "..";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";
import TextInputWithCharCount from "../TextInputWithCharCount/TextInputWithCharCount";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

class MemoryEditView extends React.Component {
  getMemoryInfos = (memory, material = "yellow-gold") => {
    if (memory && memory.fields) {
      switch (material) {
        default:
          return {
            image: memory.fields.imageYellowGoldMainURL,
            title: `${memory.fields.title}, keltakulta`,
            price: memory.fields.priceYellowGold,
          };
        case "rose-gold":
          return {
            image: memory.fields.imageRoseGoldMainURL,
            title: `${memory.fields.title}, ruusukulta`,
            price: memory.fields.priceRoseGold,
          };
        case "white-gold":
          return {
            image: memory.fields.imageWhiteGoldMainURL,
            title: `${memory.fields.title}, valkokulta`,
            price: memory.fields.priceWhiteGold,
          };
      }
    }
    return null;
  };

  onSelectMemoryButtonPress = (
    modalActiveMemory,
    modalMemoryIndex,
    modalActiveMemoryEngraving
  ) => {
    this.props.selectActiveMemory(
      modalActiveMemory.memory,
      modalMemoryIndex,
      modalActiveMemoryEngraving,
      modalActiveMemory.material
    );
    this.changeURL();
  };

  changeURL = () => {
    const {
      history,
      modalActiveMemory,
      modalMemoryIndex,
      modalActiveMemoryEngraving,
    } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    const memoryParam = `m${modalMemoryIndex}`;
    const engravingParam = `me${modalMemoryIndex}`;
    const materialParam = `mm${modalMemoryIndex}`;
    const base64Engraving = btoa(modalActiveMemoryEngraving);
    queryParams[memoryParam] = modalActiveMemory.memory.sys.id;
    queryParams[materialParam] = modalActiveMemory.material;
    queryParams[engravingParam] = base64Engraving;
    history.push({
      pathname: "/",
      search: queryString.stringify(queryParams),
    });
  };

  render() {
    const {
      modalMemoryIndex,
      modalActiveMemory,
      modalActiveMemoryEngraving,
    } = this.props;
    const memoryInfo = modalActiveMemory
      ? this.getMemoryInfos(
          modalActiveMemory.memory,
          modalActiveMemory.material
        )
      : null;
    return (
      <div className="memory-edit-view">
        <div className="memory-edit-view-header">
          <ButtonWithIcon
            onClick={() => this.props.toggleShowEditMemoryInModal(false)}
            icon="arrow-left"
            buttonText="Selaa muistoja"
            leftIcon={true}
          />
        </div>
        <div className="memory-container">
          {memoryInfo && memoryInfo.image ? (
            <div className="image-container">
              <img src={memoryInfo.image} alt="memory" />
            </div>
          ) : null}
          <div className="memory-info-container">
            {memoryInfo && memoryInfo.title ? (
              <span className="memory-title">{memoryInfo.title}</span>
            ) : null}
            {memoryInfo && memoryInfo.price ? (
              <span className="memory-price">Hinta {memoryInfo.price} €</span>
            ) : null}
            <TextInputWithCharCount
              titleText="Muistoon tuleva kaiverrus"
              additionalClass="edit-view"
            />
            <ButtonRounded
              onClick={() =>
                this.onSelectMemoryButtonPress(
                  modalActiveMemory,
                  modalMemoryIndex,
                  modalActiveMemoryEngraving
                )
              }
              buttonText="Lisää muisto"
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ configuratorPageNecklace, necklace }) => {
  const {
    modalMemoryIndex,
    modalActiveMemory,
    modalActiveMemoryEngraving,
  } = configuratorPageNecklace;

  const { activeMemories } = necklace;

  return {
    modalMemoryIndex,
    modalActiveMemory,
    modalActiveMemoryEngraving,
    activeMemories,
  };
};

export default connect(mapStateToProps, {
  toggleNecklaceSelectModal,
  toggleShowEditMemoryInModal,
  selectActiveMemory,
})(withRouter(MemoryEditView));
